import React, { useCallback } from 'react';
import { useStoreValue, storeSet } from '../../store';
import ButtonIconRadio from '../ButtonWrapper/components/ButtonIconRadio';
import PlayerPlayIcon from '../../icons/PlayerPlayIcon';
import PlayerBackwardIcon from '../../icons/PlayerBackwardIcon';
import PlayerForwardIcon from '../../icons/PlayerForwardIcon';
import PlayerStopIcon from '../../icons/PlayerStopIcon';
import PlayerPauseIcon from '../../icons/PlayerPauseIcon';

const TimelineControlsWidget = () => {
    const timelineState = useStoreValue('timelineState');
    const audioCacheLoading = useStoreValue('audioCacheLoading');
    const cueSheetLoading = useStoreValue('cueSheetLoading');
    const isLoading = cueSheetLoading || audioCacheLoading;

    const handleTimelineControl = useCallback((action) => {
        storeSet('timelineState', action);
    }, []);

    return (
        <div className="timelineControlsWidget">
            <ButtonIconRadio
                onChange={() => handleTimelineControl('backward')}
                value="backward"
                isSquare={true}
                checked={timelineState === 'backward'}
                disabled={isLoading}>
                <PlayerBackwardIcon/>
            </ButtonIconRadio>
            {timelineState === 'playing' ? (
                <ButtonIconRadio
                    onChange={() => handleTimelineControl('paused')}
                    value="pause"
                    isSquare={true}
                    checked={true}
                    disabled={isLoading}>
                    <PlayerPauseIcon/>
                </ButtonIconRadio>
            ) : (
                <ButtonIconRadio
                    onChange={() => handleTimelineControl('playing')}
                    value="play"
                    isSquare={true}
                    checked={false}
                    disabled={isLoading}>
                    <PlayerPlayIcon/>
                </ButtonIconRadio>
            )}
            <ButtonIconRadio
                onChange={() => handleTimelineControl('stopped')}
                value="stop"
                isSquare={true}
                checked={false}
                disabled={isLoading}>
                <PlayerStopIcon/>
            </ButtonIconRadio>
            <ButtonIconRadio
                onChange={() => handleTimelineControl('forward')}
                value="forward"
                isSquare={true}
                checked={timelineState === 'forward'}
                disabled={isLoading}>
                <PlayerForwardIcon/>
            </ButtonIconRadio>
        </div>
    );
};

export default TimelineControlsWidget;
